import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { Outlet } from "react-router-dom";
import theme from "../../theme";
import MainDrawer from "../../Drawer/MainDrawer";
import { useDrawerToggle } from "../../hooks/useDrawerToggle";

function MainLayout() {
  const { drawerOpen } = useDrawerToggle();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: "flex", height: "100vh", width: "100vw", overflow: "hidden" }}>
        <MainDrawer />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            padding: "16px",
            overflowX: 'auto', 
            overflowY: 'auto',
            backgroundColor: "#F6F5F4",
            transition: "margin-left 0.3s",
            marginLeft: drawerOpen ? 0 : "1px",
            boxSizing: 'border-box', 
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default MainLayout;
